import { Languages } from "../../types";
import { medicalPaymentsReportDictionary } from "./Payments";
import { MedicalAreaReportsPagesDescriptions } from "./types";

export const getMedicalAreaReportsPagesDescriptions = (systemLang: Languages): MedicalAreaReportsPagesDescriptions => ({
    PAYMENTS: medicalPaymentsReportDictionary[systemLang],
})